import { app } from '../../../../../app';

app.factory('UserLabelsService', UserLabelsService);

/** @ngInject */
function UserLabelsService($resource) {
    var rootUrl='app/rest/v2/company/:companyId/labelgroups';
    
    return $resource(rootUrl, {
        companyId : '@companyId'
    }, {
      
        'getLabels' : {
            method : 'GET',
            
            isArray : true
        },
		'getLabelsDefaultsIncluded' :{
			url: rootUrl+'?withDefaults=true',
			method : 'GET',
            isArray : true
		},
		'createLabel' :{
			method: 'POST',
			isArray: false
		},
		'getLabel':{
			url:rootUrl+'/:labelId',
			method:'GET',
			isArray:false,
			params : {
                companyId : '@companyId',
                labelId: 	'@labelId'
            }
		},
		'renameLabel':{
			url:rootUrl+'/:labelId/rename',
			method:'PUT',
			params : {
                companyId : '@companyId',
                labelId: 	'@labelId'
            }
		},
		
		'deleteLabel':{
			url:rootUrl+'/:labelId',
			method:'Delete',
			params : {
                companyId : '@companyId',
                labelId: 	'@labelId'
            }
		},
		'getCompanyUsers':{
			url:rootUrl+'/:labelId/users',
			method:'GET',
			isArray:true,
			params : {
                companyId : '@companyId',
                labelId: 	'@labelId'
            }
			
		},
		'addCompanyUsers':{
			url:rootUrl+'/:labelId/users',
			method:'POST',
			params : {
                companyId : '@companyId',
                labelId: 	'@labelId'
            }
			
		},
		'removeCompanyUsers':{
			url:rootUrl+'/:labelId/users?action=remove',
			method:'POST',
			params : {
                companyId : '@companyId',
                labelId: 	'@labelId'
            }
			
		},
		'copyCompanyUsersToLabels':{
			url:rootUrl+'/:labelId/users?action=copy',
			method:'POST',
			params : {
                companyId : '@companyId',
                labelId: 	'@labelId'
            }
			
		},
		'moveCompanyUsersToLabel':{
			url:rootUrl+'/:labelId/users?action=move&to=:toLabelId',
			method:'POST',
			params : {
                companyId : '@companyId',
                labelId: 	'@labelId',
				toLabelId: '@toLabelId'
            }
			
		},
		'addCompanyUsersToLabels':{
			url:rootUrl+'/users',
			method:'POST',
			params : {
                companyId : '@companyId'
            }
			
		}
      
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/user-labels/user-labels.service.js